<template>
  <div>
    <button @click="Integration">积分兑换</button>
    <button @click="Policy">隐私政策</button>
    <button @click="Ins">常见问题</button>
    <button @click="Protocol">用户协议</button>
    <!-- <button @click="AboutUs">关于我们</button> -->
  </div>
</template>
<script>
export default {
  name:'Em',
  data(){
    return{
      data:{}
    }
  },
  mounted(){
    this.login()
  },
  methods:{
    login(){
      var thi=this

    },
    Integration(){
      this.$router.push('./Integration')
    },
    Policy(){
      this.$router.push('./Policy')
    },
    Ins(){
      this.$router.push('./Ins')
    },
    Protocol(){
      this.$router.push('./Protocol')
    },
    AboutUs(){
      this.$router.push('./AboutUs')
    }
  }
}
</script>
